module.exports = __webpack_public_path__ + "img/sdm3.964485d7.jpg";